var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneytransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 512,
    viewBox: "0 0 640 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535 41C525.6 31.6 525.6 16.4 535 7.1C544.4 -2.2 559.6 -2.3 568.9 7.1L632.9 71.1C637.4 75.6 639.9 81.7 639.9 88.1C639.9 94.5 637.4 100.6 632.9 105.1L568.9 169.1C559.5 178.5 544.3 178.5 535 169.1C525.7 159.7 525.6 144.5 535 135.2L558 112.2L384 112C370.7 112 360 101.3 360 88C360 74.7 370.7 64 384 64H558.1L535 41ZM105 377L82 400H256C269.3 400 280 410.7 280 424C280 437.3 269.3 448 256 448H81.9L104.9 471C114.3 480.4 114.3 495.6 104.9 504.9C95.5 514.2 80.3 514.3 71 504.9L7 441C2.5 436.5 0 430.4 0 424C0 417.6 2.5 411.5 7 407L71 343C80.4 333.6 95.6 333.6 104.9 343C114.2 352.4 114.3 367.6 104.9 376.9L105 377ZM96 64H337.9C334.2 71.2 332 79.3 332 88C332 116.7 355.3 140 384 140H501.4C497.4 157 502 175.5 515.2 188.8C535.5 209.1 568.4 209.1 588.7 188.8L608 169.5V384C608 419.3 579.3 448 544 448H302.1C305.8 440.8 308 432.7 308 424C308 395.3 284.7 372 256 372H138.6C142.6 355 138 336.5 124.8 323.2C104.5 302.9 71.6 302.9 51.3 323.2L32 342.5V128C32 92.7 60.7 64 96 64ZM160 128H96V192C131.3 192 160 163.3 160 128ZM544 320C508.7 320 480 348.7 480 384H544V320ZM320 352C345.461 352 369.879 341.886 387.882 323.882C405.886 305.879 416 281.461 416 256C416 230.539 405.886 206.121 387.882 188.118C369.879 170.114 345.461 160 320 160C294.539 160 270.121 170.114 252.118 188.118C234.114 206.121 224 230.539 224 256C224 281.461 234.114 305.879 252.118 323.882C270.121 341.886 294.539 352 320 352Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneytransfer);
export default __webpack_public_path__ + "static/media/moneytransfer.b5475fb2eba38e0b0fe150d2d7273015.svg";
export { ForwardRef as ReactComponent };